export const Svg_097 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M35 64.167c-6.66 0-12.214-2.285-16.662-6.854-4.448-4.57-6.672-10.257-6.672-17.063 0-4.86 1.933-10.147 5.797-15.859C21.328 18.68 27.173 12.494 35 5.834c7.826 6.66 13.672 12.845 17.536 18.557 3.865 5.712 5.797 10.998 5.797 15.86 0 6.805-2.224 12.492-6.672 17.062-4.448 4.57-10.002 6.854-16.661 6.854Zm0-5.833c5.055 0 9.236-1.714 12.541-5.14 3.306-3.428 4.959-7.742 4.959-12.944 0-3.548-1.47-7.559-4.412-12.03-2.94-4.473-7.304-9.358-13.088-14.657-5.785 5.299-10.148 10.184-13.089 14.656-2.94 4.472-4.411 8.483-4.411 12.032 0 5.2 1.652 9.515 4.958 12.942 3.306 3.427 7.486 5.14 12.542 5.14ZM26.25 52.5h17.5v-5.833h-17.5v5.834Zm5.833-8.75h5.833v-5.833h5.834v-5.833h-5.834V26.25h-5.833v5.834H26.25v5.833h5.833v5.834Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={22.458}
        x2={52.434}
        y1={14.584}
        y2={53.395}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)